import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useImperativeHandle, useRef } from 'react';
import { useOnClickOutside } from '@flywire/react-hooks';
import { Context, Provider } from './Context';
import { ComboboxError } from './Error';
import { Field } from './Field';
import { Input } from './Input';
import { Label } from './Label';
import { Option } from './Option';
import { Options } from './Options';
import { DISPLAY_NAME_COMBOBOX, DISPLAY_NAME_WRAPPER } from './constants';
const ComboboxComponent = forwardRef(({ as: Element = 'div', children, className }, forwardedRef) => {
    const internalRef = useRef(null);
    const { isOpen, setIsOpen } = useContext(Context);
    useImperativeHandle(forwardedRef, () => internalRef.current);
    useOnClickOutside(internalRef, useCallback(() => setIsOpen(false), [setIsOpen]));
    return (_jsx(Element, { ref: internalRef, className: className, "data-state": isOpen ? 'open' : null, children: children }));
});
ComboboxComponent.displayName = DISPLAY_NAME_COMBOBOX;
const Wrapper = forwardRef(({ as = 'div', className, id, children, ...rest }, ref) => {
    return (_jsx(Provider, { id: id, ...rest, children: _jsx(ComboboxComponent, { as: as, ref: ref, className: className, children: children }) }));
});
Wrapper.displayName = DISPLAY_NAME_WRAPPER;
const Combobox = Wrapper;
Combobox.displayName = DISPLAY_NAME_COMBOBOX;
Combobox.Error = ComboboxError;
Combobox.Field = Field;
Combobox.Input = Input;
Combobox.Label = Label;
Combobox.Option = Option;
Combobox.Options = Options;
export { Combobox };
//# sourceMappingURL=Combobox.js.map